import { createJSONStorage, type StateStorage } from 'zustand/middleware'

/** localStorage that never throws (private mode, blocked storage, previews). */
const safeLocalStorage: StateStorage = {
  getItem: (key) => {
    try {
      return window.localStorage.getItem(key)
    } catch {
      return null
    }
  },
  setItem: (key, value) => {
    try {
      window.localStorage.setItem(key, value)
    } catch {
      /* storage unavailable: preferences simply won't persist */
    }
  },
  removeItem: (key) => {
    try {
      window.localStorage.removeItem(key)
    } catch {
      /* ignore */
    }
  },
}

export const persistStorage = createJSONStorage(() => safeLocalStorage)

export function clearLocalData(keys: string[]) {
  for (const k of keys) safeLocalStorage.removeItem(k)
}
